"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextButton = exports.PasswordResetSection = exports.PasswordResetLink = exports.DangerZoneSection = exports.BannedMessage = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _get = _interopRequireDefault(require("lodash/get"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactCopyToClipboard = require("react-copy-to-clipboard");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Button = _interopRequireDefault(require("../../../../components/Button"));
var _excluded = ["color", "children", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SubAccountDetailModal = function SubAccountDetailModal(_ref) {
  var email = _ref.email,
    onClose = _ref.onClose,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8 bg-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex pb-4"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "flex-1 text-3xl font-bold truncate"
  }, email), /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-gray-medium hover:text-gray-dark",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    fontSize: "large"
  }))), children);
};
var _default = exports["default"] = SubAccountDetailModal;
var Section = function Section(_ref2) {
  var header = _ref2.header,
    title = _ref2.title,
    description = _ref2.description,
    children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "py-2"
  }, !!header && /*#__PURE__*/_react["default"].createElement("h4", {
    className: "text-2xl font-bold pb-2"
  }, header), !!title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uppercase text-gray-medium text-sm font-semibold"
  }, title), !!description && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs text-gray-light"
  }, description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-12 flex items-center"
  }, children));
};
var TextButton = exports.TextButton = function TextButton(_ref3) {
  var color = _ref3.color,
    children = _ref3.children,
    onClick = _ref3.onClick,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var colorSchema = {
    primary: 'text-primary',
    error: 'text-red'
  };
  var colorClassNames = (0, _get["default"])(colorSchema, color, colorSchema.primary);
  var _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('text-lg font-semibold', (0, _defineProperty2["default"])({
      'text-gray-light': disabled
    }, "".concat(colorClassNames, " hover:opacity-75"), !disabled)),
    onClick: onClick
  }), children);
};
var PasswordResetSection = exports.PasswordResetSection = function PasswordResetSection(_ref4) {
  var children = _ref4.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(Section, {
    title: t('settings.customDomain.subAccountDetail.passwordReset.title'),
    description: t('settings.customDomain.subAccountDetail.passwordReset.description')
  }, children);
};
var PasswordResetLink = exports.PasswordResetLink = function PasswordResetLink(_ref5) {
  var link = _ref5.link;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    disabled = _useState2[0],
    setDisabled = _useState2[1];
  function handleOnCopy() {
    setDisabled(true);
    setTimeout(function () {
      return setDisabled(false);
    }, 1500);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full bg-secondary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-gray-medium inline-flex flex-1 items-center text-sm py-2 overflow-x-scroll whitespace-no-wrap mx-3"
  }, link), /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
    text: link,
    onCopy: handleOnCopy
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    className: "w-24 text-sm select-none"
  }, disabled ? t('button.copied') : t('button.copy'))));
};
var DangerZoneSection = exports.DangerZoneSection = function DangerZoneSection(_ref6) {
  var children = _ref6.children;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(Section, {
    header: t('settings.customDomain.subAccountDetail.dangerZone'),
    title: t('settings.customDomain.subAccountDetail.dangerZone.title'),
    description: t('settings.customDomain.subAccountDetail.dangerZone.description')
  }, children);
};
var BannedMessage = exports.BannedMessage = function BannedMessage() {
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: "my-4 text-sm text-light"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "settings.customDomain.subaccountDetail.messages.banned"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    rel: "noopener noreferrer",
    href: t('supportSite'),
    target: "_blank",
    className: "text-primary hover:underline"
  }, t('supportSite'))));
};
//# sourceMappingURL=SubAccountDetail.js.map